/**
 * Hero Banner JavaScript
 * Add any interactive functionality for the hero banner here
 */

document.addEventListener('DOMContentLoaded', function() {
  initHeroBanner();
});

function initHeroBanner() {
  console.log('Hero Banner initialized');
  
  // Add any interactive functionality here
  // Examples:
  // - Auto-play/pause video controls
  // - Parallax effects
  // - Animation triggers
  // - Dynamic content loading
  
  handleVideoAutoplay();
  handleBannerInteractions();
}

/**
 * Handle video autoplay functionality
 */
function handleVideoAutoplay() {
  const videos = document.querySelectorAll('.banner-video');
  
  videos.forEach(video => {
    // Ensure video plays when in viewport
    const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          video.play().catch(e => console.log('Video autoplay prevented:', e));
        } else {
          video.pause();
        }
      });
    }, { threshold: 0.5 });
    
    observer.observe(video);
    
    // Handle video loading errors
    video.addEventListener('error', function() {
      console.warn('Video failed to load, showing fallback image');
      // Could show fallback image here
    });
  });
}

/**
 * Handle banner interactions
 */
function handleBannerInteractions() {
  const bannerLinks = document.querySelectorAll('.banner-link');
  const buttons = document.querySelectorAll('.banner-content .btn');
  
  // Prevent banner link from interfering with button clicks
  buttons.forEach(button => {
    button.addEventListener('click', function(e) {
      e.stopPropagation();
    });
  });
  
  // Optional: Add keyboard navigation support
  bannerLinks.forEach(link => {
    link.addEventListener('keydown', function(e) {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        this.click();
      }
    });
  });
}

/**
 * Optional: Add parallax effect to hero banner
 * Uncomment and customize as needed
 */
/*
function addParallaxEffect() {
  const heroBanners = document.querySelectorAll('.hero-banner');
  
  window.addEventListener('scroll', () => {
    const scrolled = window.pageYOffset;
    const rate = scrolled * -0.5;
    
    heroBanners.forEach(banner => {
      const bannerImage = banner.querySelector('.banner-image, .banner-video');
      if (bannerImage) {
        bannerImage.style.transform = `translate3d(0, ${rate}px, 0)`;
      }
    });
  });
}
*/

/**
 * Optional: Add fade-in animation on scroll
 * Uncomment and customize as needed
 */
/*
function addScrollAnimations() {
  const bannerContent = document.querySelectorAll('.banner-content');
  
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
      }
    });
  }, { threshold: 0.1 });
  
  bannerContent.forEach(content => {
    content.style.opacity = '0';
    content.style.transform = 'translateY(30px)';
    content.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
    observer.observe(content);
  });
}
*/